export interface GetLoadsRequest {
  dateTimeFrom?: string;
  dateTimeTo?: string;
  orderId?: number;
}
